import script from "./Hint.vue?vue&type=script&setup=true&lang=js"
export * from "./Hint.vue?vue&type=script&setup=true&lang=js"

import "./Hint.vue?vue&type=style&index=0&id=42e7d27b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42e7d27b"]])

export default __exports__